export const timeControlString = ({ limit, increment }) => {
    return `${limit / (60 * 1000)}+${increment / 1000}`;
};
export const parseTimeControlString = (timeControlString) => {
    const [limit, increment] = timeControlString.split("+");
    return {
        limit: Number.parseInt(limit) * 60 * 1000,
        increment: Number.parseInt(increment) * 1000,
    };
};
//# sourceMappingURL=timeControlString.js.map